import React, { useMemo } from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import * as am4charts from '@amcharts/amcharts4/charts';

import { IAccessPointDroppedConnectionsTrend } from '../../../../services/core/accessPoints';
import { Tooltip } from '../../../../components/tooltip/tooltip';
import { StackedColumnsDateChart } from '@components/chart/stackedColumnsDateChart';

import './charts.css';
import { drawAccessPointSamplesXAxisLabels, formatTooltipHour } from './coreAccessPointSamples';
import { DateRange } from '..';

interface IProps {
  data: IAccessPointDroppedConnectionsTrend[],
  dateRange: DateRange,
  onMount: (chart: am4charts.XYChart) => am4charts.XYChart
}

export const CoreAccessPointDroppedConnections = (props: IProps) => {
  const { data, dateRange } = props;
  const { t } = useTranslation('coreAccessPoints');
  const droppedConnectionsData = useMemo(() => data.some(d => d.count !== null) ? data : [], [data]);

  return (
    <div className="core-access-point-chart-section">
      <StackedColumnsDateChart<IAccessPointDroppedConnectionsTrend>
        data={droppedConnectionsData}
        className="core-ap-dropped-connections-by-time-chart"
        series={[{
          dataKey: 'count',
          description: t('DROPPED_CONNECTIONS'),
          visible: true,
          colour: '#5b9ad2',
        }]}
        title={
          <>
            {t('DROPPED_CONNECTIONS_BY_TIME')}{' '}
            <Tooltip popperContent={t('DROPPED_CONNECTIONS_BY_TIME_TOOLTIP')} placement="right">
              <i className="fa fa-question-circle" style={{ color: '#7490b9', cursor: 'pointer' }} />
            </Tooltip>
          </>
        }
        columnWidth={10}
        onMount={props.onMount}
        xAxisType={'date'}
        yAxisType={'value'}
        formatTooltipDate={formatTooltipHour}
        cypressId={'coreAccessPointDroppedConnectionsByTime'}
        hasLegend={true}
        drawXAxis={(_, xAxis) => drawAccessPointSamplesXAxisLabels(xAxis as am4charts.DateAxis, dateRange)}
        useAxisTooltip
      />
    </div>
  );
};
